

export class ViajeVisita {

  //  public  idCompania: string;
  //  public  idUsuario: string;
  //  public  idVehiculo: string;
  //  public  idViaje: string;
    public  fechaCreacion: Date;
    public  fechaAsignacion: Date;
    public  fechaSincronizacionMovil: Date;
    public  fechaSincronizaacionNube: Date;
    public  estado: string;


public  idCompania: string;
public  idUsuario: string;
public  idVehiculo: string;
public  idViaje: string;
public  idVisita: string;
public  fechaInicio: Date;
public  fechaFinalizacion: Date;

public  estadoViajeVisita: string;



}